<script lang="ts" setup>
import IconArrowLeft from "~/components/sx/icons/IconArrowLeft.vue";
import IconHouse from "~/components/sx/icons/IconHouse.vue";

interface IProps {
  statusCode?: number | undefined,
  devMode?: boolean
}

const { devMode = false, statusCode } = defineProps<IProps>();

const router = useRouter();
const { locale: localeI18n } = useI18n();
</script>

<template>
  <div class="error">
    <div class="error__content">
      <div class="error__image">
        <template v-if="!devMode">
          <img v-if="statusCode === 404" src="~/assets/images/404.png" alt="error" loading="lazy" />
          <img v-else src="~/assets/images/505.png" alt="error" loading="lazy" />
        </template>
        <template v-else>
          <img src="~/assets/images/dev-mode.png" alt="page_under_development" loading="lazy">
        </template>
      </div>

      <div  class="error__section">
        <div v-if="!devMode" class="error__text">
          <template v-if="statusCode === 404">
            <span class="sx-landing-title">404 — {{ $t('components.error.404.title') }}</span>
          </template>
          <template v-else>
            <span class="sx-landing-title">500 — {{ $t('components.error.500.title') }}</span>
          </template>
        </div>
        <div v-else class="error__text">
          <span class="sx-landing-title">{{ $t('components.error.devMode.title') }}</span>
          <div class="error__description">
            <span>{{ $t('components.error.devMode.description1') }}</span><br>
            <span>{{ $t('components.error.devMode.description2') }}</span>
          </div>
        </div>
        <div class="error__controls">
          <span class="error__btn sx--btn sx--btn--transparent" @click.stop="router.back()">
            <icon-arrow-left />
            {{ $t('components.error.back') }}
          </span>
          <NuxtLink class="error__btn error__btn--lg sx--btn" :to="`/${localeI18n}`">
            <icon-house />
            {{ $t('components.error.toHome') }}
          </NuxtLink>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.error {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 2rem 4rem;

  &__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 36px;
    width: 100%;
  }

  &__image {
    max-width: 410px;

    img {
      width: 100%;
    }
  }

  &__section {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 32px;
  }

  &__text {
    font-family: ALS Hauss, sans-serif;
    font-size: 75px;
    font-weight: 700;
    line-height: 80px;
    letter-spacing: -0.03em;
    text-align: center;
  }

  &__description {
    margin-top: 16px;
    font-size: 24px;
    font-weight: 400;
    line-height: 33.6px;
    letter-spacing: -0.03em;
    text-align: center;
    @media (max-width: 600px) {
      font-size: 16px;
      line-height: 20px;
    }
  }

  &__controls {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  &__btn {
    display: flex;
    cursor: pointer;
    align-items: center;
    justify-content: center;
    gap: 7px;
    height: 56px;
    min-width: 126px;
    padding: 16px 20px 16px !important;
    font-size: 18px;
    @media (max-width: 600px) {
      height: 44px;
      padding: 0 16px;
      border-radius: 22px;
      font-size: 16px;
    }

    &--lg {
      min-width: 171px;
    }
  }
}
</style>
